import React from "react";

const NameDisplay = ({ name, textStyle, maxLength = 25 }) => {
  const truncateName = (name, maxLength = 20) => {
    if (!name) return "Not set";
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength) + "...";
  };
  const isLong = name && name.length > maxLength;
  const displayName = isLong
    ? truncateName(name, maxLength)
    : name || "Not set";
  return (
    <h3
      className={`${textStyle} mb-0 profile-name-truncate`}
      title={isLong ? name : undefined}
      style={{ cursor: isLong ? "help" : "default", color: "#e6ecf1" }}
    >
      {displayName}
    </h3>
  );
};

export default NameDisplay;
